// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  encryptionSecret: 'tZJaq72y3buBxQAPTPv4',
  encryptionNamespace: 'v-four-dashboard',
  hasuraAdminSecret: 'narmettahasura123',
  httpHasuraUrl: `https://hasura.narmetta.com/v1/graphql`,
  wssHasuraUrl: `wss://hasura.narmetta.com/v1/graphql`,
  authServerUrl: 'https://api.narmetta.com',
  googleMapApiKey: 'AIzaSyBUO6cvOYU0nhH_N7N6_Ymsbze8dRisRlU_test',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

//httpHasuraUrl: `https://narmetta-dev.hasura.app/v1/graphql`,

